/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
if (process.env.NODE_ENV === 'production') {
  baseApiUrl = 'https://mub-issue-tracking-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://mub-issue-tracking-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/mu-issue-tracking-tool-api/public/'
  appBaseUrl = 'http://localhost:2200/#/'
}

export {
  baseApiUrl,
  appBaseUrl
}
